'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
var _extends = require('../../extends-733dd656.js');
require('../../objectWithoutProperties-c6d3675c.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
var taggedTemplateLiteral = require('../../taggedTemplateLiteral-f923b98d.js');
var styled = require('styled-components');
require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
require('../../xstyled-prop-types.es-4220f7f4.js');
require('../../unsupportedIterableToArray-f175acfa.js');
var styles_breakpoints = require('../../breakpoints-ee0a4ae5.js');
require('../../components/GlobalStyle/GlobalStyle.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');
require('../../components/NuDSProvider/NuDSProvider.js');
var slicedToArray = require('../../slicedToArray-a8a77f0e.js');
require('../../utils/isType/isType.js');
require('../../defineProperty-3cad0327.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
require('../../Icon-efcd1bee.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
var components_Typography_Typography = require('../../components/Typography/Typography.js');
require('../../utils/ref/refType.js');
require('../../withIntlAriaAttrs-d3af74a8.js');
var components_Button_Button = require('../../components/Button/Button.js');
var components_Link_Link = require('../../components/Link/Link.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var AnnouncementBarAccessibilityContext = /*#__PURE__*/React__default['default'].createContext();

var Text = function Text(props) {
  var identifier = React.useContext(AnnouncementBarAccessibilityContext);
  return /*#__PURE__*/React__default['default'].createElement(components_Typography_Typography['default'], _extends._extends_1({
    variant: "paragraph2"
  }, props, {
    id: identifier
  }));
};

function _templateObject2() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    padding: 1rem 3.5rem 1rem 3.5rem;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var AnnouncementBarWrapper = styled__default['default'].div.withConfig({
  displayName: "AnnouncementBarWrapper",
  componentId: "sc-13bev3u-0"
})(["position:absolute;width:100%;padding:1.5rem;display:flex;background:", ";overflow:hidden;will-change:transform,opacity;transition:all .2s ease-out;", " ", " ", ""], styles_themeUtils.nuDSColor('primary', 'defaultL10'), function (_ref) {
  var isVisible = _ref.isVisible;
  return !isVisible && styled.css(["transform:translate3d(0,-100%,0);opacity:0;pointer-events:none;"]);
}, styles_breakpoints.tablet768(_templateObject()), styles_breakpoints.desktop1024(_templateObject2()));
AnnouncementBarWrapper.displayName = 'AnnouncementBarWrapper';
AnnouncementBarWrapper.propTypes = {
  isVisible: index.propTypes.bool.isRequired
};

function _templateObject$1() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n  "]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var ContentWrapper = styled__default['default'].div.withConfig({
  displayName: "ContentWrapper",
  componentId: "sc-1ggx1zr-0"
})(["flex:1;", ""], styles_breakpoints.desktop1024(_templateObject$1()));
ContentWrapper.displayName = 'ContentWrapper';

var CloseButtonWrapper = styled__default['default'].div.withConfig({
  displayName: "CloseButtonWrapper",
  componentId: "sc-9twor6-0"
})(["margin-left:1.5rem;"]);
CloseButtonWrapper.displayName = 'CloseButtonWrapper';

var CTA = function CTA(props) {
  return /*#__PURE__*/React__default['default'].createElement(components_Link_Link['default'], _extends._extends_1({
    variant: "action"
  }, props));
};

function _templateObject$2() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    margin-top: 0;\n    margin-left: 1.5rem;\n  "]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var SyledCTA = styled__default['default'](CTA).withConfig({
  displayName: "CTA__SyledCTA",
  componentId: "sc-1eosly3-0"
})(["white-space:nowrap;margin-top:1.5rem;", ""], styles_breakpoints.desktop1024(_templateObject$2()));
SyledCTA.displayName = 'CTA';

var CloseButton = styled__default['default'](components_Button_Button['default']).withConfig({
  displayName: "CloseButton",
  componentId: "sc-1m574bt-0"
})(["width:1.5rem;height:1.5rem;"]);
CloseButton.displayName = 'CloseButton';

function AnnouncementBar(_ref) {
  var children = _ref.children,
      className = _ref.className,
      identifier = _ref.identifier,
      initiallyVisible = _ref.initiallyVisible,
      onClose = _ref.onClose;

  var _useState = React.useState(initiallyVisible),
      _useState2 = slicedToArray.slicedToArray(_useState, 2),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1];

  var handleClose = function handleClose() {
    setIsVisible(false);
    if (onClose) onClose();
  };

  React.useEffect(function () {
    setIsVisible(initiallyVisible);
  }, [initiallyVisible]);
  return /*#__PURE__*/React__default['default'].createElement(AnnouncementBarAccessibilityContext.Provider, {
    value: identifier
  }, /*#__PURE__*/React__default['default'].createElement(AnnouncementBarWrapper, {
    role: "dialog",
    "aria-labelledby": identifier,
    className: className,
    isVisible: isVisible
  }, /*#__PURE__*/React__default['default'].createElement(ContentWrapper, null, children), /*#__PURE__*/React__default['default'].createElement(CloseButtonWrapper, null, onClose && /*#__PURE__*/React__default['default'].createElement(CloseButton, {
    variant: "basic",
    styleVariant: "black",
    iconProps: {
      name: 'x'
    },
    role: "button",
    "aria-label": "close",
    onClick: handleClose
  }))));
}

AnnouncementBar.Text = Text;
AnnouncementBar.CTA = SyledCTA;
AnnouncementBar.propTypes = {
  children: index.propTypes.node.isRequired,
  className: index.propTypes.string,
  identifier: index.propTypes.string.isRequired,
  initiallyVisible: index.propTypes.bool,
  onClose: index.propTypes.func
};
AnnouncementBar.defaultProps = {
  className: undefined,
  initiallyVisible: true,
  onClose: undefined
};

exports.default = AnnouncementBar;
//# sourceMappingURL=AnnouncementBar.js.map
